import React from "react";
import { Link } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand">
              <span className="brand-icon">
                <FiHome />
              </span>
              Home Discovery
            </div>
            <p className="mb-3" style={{ fontSize: "0.9rem", lineHeight: 1.7 }}>
              Your trusted partner in finding the perfect home in Kigali, Rwanda.
              We connect property seekers with their dream homes through a modern,
              seamless experience.
            </p>
            <div className="social-icons">
              <a href="#!"><FaFacebookF /></a>
              <a href="#!"><FaTwitter /></a>
              <a href="#!"><FaInstagram /></a>
              <a href="#!"><FaLinkedinIn /></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-6">
            <h5>Quick Links</h5>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/properties">Properties</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h5>Property Types</h5>
            <ul>
              <li><Link to="/properties">Villas</Link></li>
              <li><Link to="/properties">Apartments</Link></li>
              <li><Link to="/properties">Townhouses</Link></li>
              <li><Link to="/properties">Commercial</Link></li>
              <li><Link to="/properties">Duplexes</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h5>Contact Info</h5>
            <ul>
              <li style={{ marginBottom: "0.75rem" }}>
                <span style={{ color: "var(--gray-300)" }}>📍</span>{" "}
                KG 123 St, Kigali, Rwanda
              </li>
              <li style={{ marginBottom: "0.75rem" }}>
                <span style={{ color: "var(--gray-300)" }}>📞</span>{" "}
                +250799000000
              </li>
              <li style={{ marginBottom: "0.75rem" }}>
                <span style={{ color: "var(--gray-300)" }}>✉️</span>{" "}
                info@homediscovery.rw
              </li>
              <li>
                <span style={{ color: "var(--gray-300)" }}>🕐</span>{" "}
                Mon - Sat: 8:00 AM - 6:00 PM
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="mb-0">
            © {new Date().getFullYear()} Home Discovery. All rights reserved. Made with ❤️ in Kigali
          </p>
        </div>
      </div>
    </footer>
  );
}
